"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Calendar_1 = require("./Calendar");
var StringUtils_1 = require("./StringUtils");
var TextUtils_1 = require("./TextUtils");
var ObjUtils = /** @class */ (function () {
    function ObjUtils() {
    }
    ObjUtils.IsNothing = function (Value) {
        return Value == null || Value == undefined || Value == 'undefined';
    };
    ObjUtils.IsNumeric = function (Value) {
        return !isNaN(Value);
    };
    ObjUtils.IsFloat = function (Value) {
        if (ObjUtils.IsNothing(Value))
            return false;
        return ObjUtils.IsNumeric(Value) && !Number.isInteger(Value);
    };
    ObjUtils.IsInt = function (Value) {
        if (ObjUtils.IsNothing(Value))
            return false;
        return ObjUtils.IsNumeric(Value) && Number.isInteger(Value);
    };
    ObjUtils.EqualObj = function (oldVal, Value) {
        return oldVal === Value;
    };
    ObjUtils.ZeroCalendarTime = function (dt) {
        dt.getTime().setHours(0);
        dt.getTime().setMinutes(0);
        dt.getTime().setSeconds(0);
        dt.getTime().setMilliseconds(0);
        return dt;
    };
    ObjUtils.SafeToCalendar = function (Value) {
        if (Value instanceof Calendar_1.default)
            return Value;
        if (Value instanceof Date) {
            return new Calendar_1.default(Value);
        }
        return this.SafeToComplexDate(StringUtils_1.default.SafeToString(Value));
    };
    ObjUtils.SafeToDate = function (Value) {
        if (Value instanceof Calendar_1.default)
            return Value.getTime();
        if (Value instanceof Date) {
            return Value;
        }
        var dt = this.SafeToComplexDate(StringUtils_1.default.SafeToString(Value));
        if (dt)
            return dt.getTime();
        return null;
    };
    ObjUtils.SafeToDateString = function (Value) {
        if (Value instanceof Calendar_1.default)
            return Value.toString();
        if (Value instanceof Date)
            Value.toDateString();
        return StringUtils_1.default.SafeToString(Value);
    };
    ObjUtils.getOnlyTime = function (Value) {
        return Value.getHours().toString().padStart(2, "0") + ":" + Value.getMinutes().toString().padStart(2, "0");
    };
    ObjUtils.SafeToHours = function (Value) {
        if (!Value)
            return this.getOnlyTime(new Date());
        if (Value instanceof Calendar_1.default)
            return this.getOnlyTime(Value.getTime());
        if (Value instanceof Date) {
            return this.getOnlyTime(Value);
        }
        return this.getOnlyTime(this.SafeToComplexDate(StringUtils_1.default.SafeToString(Value)).getTime());
    };
    ObjUtils.getDateSeparator = function (str) {
        var sep = ["-", "/"];
        for (var s in sep) {
            if (str.indexOf(s) > 0) {
                return s;
            }
        }
        return "/";
    };
    ObjUtils.SafeToComplexDate = function (sDate) {
        if (TextUtils_1.default.isEmpty(sDate)) {
            return null;
        }
        var regex = /\//g;
        sDate = sDate.trim().replace("T", " ");
        var calendar = Calendar_1.default.getInstance();
        var sSeparator = this.getDateSeparator(sDate);
        if (sSeparator == "/")
            sDate = sDate.replace(regex, '-');
        return new Calendar_1.default(Date.parse(sDate));
        // let sPattern="";
        // if (sDate.indexOf(sSeparator) == 4) {
        //     // Debe ser el formato de SQLite
        //     if (sDate.length <= 10) {
        //         sPattern = "yyyy" + sSeparator + "MM" + sSeparator + "dd";
        //     } else {
        //         sPattern = "yyyy" + sSeparator + "MM" + sSeparator + "dd HH:mm:ss";
        //     }
        //     return new Calendar(Date.parse(sDate));
        // } else {
        //     sPattern = getDateFormat(Locale.getDefault(), sDate, sSeparator);
        //     if (sDate.length() <= 10) {
        //         sPattern = sPattern.substring(0, sPattern.lastIndexOf("y"));
        //     }
        // }
        // SimpleDateFormat formatter = new SimpleDateFormat(sPattern, Locale.US);
        // Date date = unsafeParseDate(formatter, sDate);
        // calendar.setTime(date);
        // return calendar;
    };
    /**
     * Dado un objeto, devuelve el marcador de tipo interno.
     *
     * @param Source Objeto cuyo marcador de tipo interno se quiere obtener.
     * @return Devuelve el marcador de tipo del objeto.
     */
    ObjUtils.GetTypeTag = function (Source) {
        if (Source == null) {
            return this.OBJ_TYPE_NULL;
        }
        if (typeof Source === 'number' || Source instanceof Number) {
            if (Number.isInteger(Source))
                return this.NATIVE_TYPE_LONG;
            else
                return this.NATIVE_TYPE_DOUBLE;
        }
        if (typeof Source === 'boolean' || Source instanceof Boolean) {
            return this.NATIVE_TYPE_BOOL;
        }
        if (typeof Source === 'string' || Source instanceof String) {
            return this.OBJ_TYPE_STRING;
        }
        if (Source instanceof Date) {
            return this.OBJ_TYPE_DATE;
        }
        if (Source instanceof Calendar_1.default) {
            return this.OBJ_TYPE_CALENDAR;
        }
        return this.NOT_NATIVE_TYPE;
    };
    ObjUtils.NATIVE_TYPE_LONG = 1;
    ObjUtils.NATIVE_TYPE_INT = 2;
    ObjUtils.NATIVE_TYPE_BOOL = 3;
    ObjUtils.NATIVE_TYPE_DOUBLE = 4;
    ObjUtils.NATIVE_TYPE_FLOAT = 5;
    ObjUtils.OBJ_TYPE_STRING = 100;
    ObjUtils.OBJ_TYPE_DATE = 101;
    ObjUtils.OBJ_TYPE_CALENDAR = 102;
    ObjUtils.OBJ_TYPE_NULL = 103;
    ObjUtils.NOT_NATIVE_TYPE = -1;
    return ObjUtils;
}());
exports.default = ObjUtils;

//# sourceMappingURL=ObjUtils.js.map
